<template>
  <div class="banner">
    <div class="sidebar-wrapper">
      <sidebar :courseTypeList="courseTypeList"></sidebar>
    </div>
    <div class="slider-wrapper">
      <slider></slider>
    </div>
  </div>
</template>

<script>
import Slider from './slider'
import Sidebar from './sidebar'
export default {
  props: {
    courseTypeList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  components: {
    Slider,
    Sidebar
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
  @import '~@/styles/base.scss';
  .banner {
    margin-top: 30px;
    .sidebar-wrapper {
      width: 240px;
      height: 450px;
      float: left;
    }
    .slider-wrapper {
      float: right;
       height: 450px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home/components/banner.vue